var windowScrollCallbacks = [],
    windowResizeCallbacks = []


window.onscroll = (e) => {

    windowScrollCallbacks.forEach((callback) => {

        callback(e)

    })

}

window.onresize = (e) => {

    windowResizeCallbacks.forEach((callback) => {

        callback(e)

    })

}

function addScrollCallback(callback) {

    windowScrollCallbacks.push(callback)

}

function addResizeCallback(callback) {

    windowResizeCallbacks.push(callback)

}

function scrollTo(id, position = 'center') {

    let el    = document.getElementById(id)
    el.scrollIntoView({ behavior: 'smooth', block: position } )

    return false;

}

function initParallaxBackgroundElements() {

    var parallaxBackgroundElements = document.querySelectorAll('[data-parallax="background"]'),
        coords = 0

    parallaxBackgroundElements.forEach((element) => {

        element.style.backgroundAttachment = 'fixed'

    })

    addScrollCallback(() => {

        parallaxBackgroundElements.forEach((element) => {

            coords = `${ -window.pageYOffset / +element.dataset.speed }px`

            element.style.backgroundPositionY = coords

        })

    })

}

function initParallaxBlockElements() {

    var parallaxBlockElements = document.querySelectorAll('[data-parallax="block"]'),
        coords = 0

    addScrollCallback(() => {

        parallaxBlockElements.forEach((element) => {

            coords = `${ window.pageYOffset / (1 / +element.dataset.speed) }px`

            element.style.transform = `translate(0, ${ coords })`

        })

    })

}

function initParallaxImageElements() {

    var parallaxImageElements = document.querySelectorAll('[data-parallax="image"]')

    parallaxImageElements.forEach((image) => {

        image.style.transform = `translate(${ image.dataset.defaultXOffset }px, -${ image.dataset.defaultYOffset }px)`
        image.style.transition = '0.3s ease-out'

    })

    var y              = 0,
        animateLength  = 0,
        offsetBottom   = 0,
        screenProgress = 0

    var xOffset       = 0,
        yOffset       = 0,
        progressRatio = 0

    var zoomTransform,
        zoomProgress

    addScrollCallback(() => {

        parallaxImageElements.forEach((image) => {

            y = image.getBoundingClientRect().y
            animateLength  = window.innerHeight * +image.dataset.animateLength
            offsetBottom   = (window.innerHeight - y)
            progressRatio  = 1 - (offsetBottom / animateLength)
            screenProgress = offsetBottom / window.innerHeight

            if (offsetBottom >= 0) {

                xOffset = Math.floor(progressRatio * +image.dataset.defaultXOffset)
                yOffset = Math.floor(progressRatio * +image.dataset.defaultYOffset)

                if (offsetBottom < animateLength) {

                    image.style.transform = `translate(${ xOffset }px, ${ -yOffset }px)`

                } else {

                    image.style.transform = `translate(${ 0 }px, ${ 0 }px)`

                }

                if (image.dataset.parallaxZoom) {

                    if (screenProgress > +image.dataset.parallaxZoomDelay) {

                        zoomProgress = screenProgress > +image.dataset.parallaxZoomDelay + +image.dataset.parallaxZoomLength ? 1 : (screenProgress - +image.dataset.parallaxZoomDelay) / +image.dataset.parallaxZoomLength

                        zoomTransform = `scale(${ (+image.dataset.parallaxZoom * zoomProgress) + 1 }) translate(${ +image.dataset.defaultZoomXOffset * zoomProgress }px, ${ +image.dataset.defaultZoomYOffset * zoomProgress }px)`

                        image.childNodes[0].style.transform = zoomTransform

                    } else {

                        image.childNodes[0].style.transform = `scale(1) translate(0px, 0px)`

                    }

                }

            }

        })

    })

}

function initParallaxNavbarActive() {

    var nodeListAnchors    = document.querySelectorAll('[data-anchor]'),
        anchors            = [],
        currentAnchorIndex = 0,
        anchorActiveBar    = document.querySelector('[data-anchor-active-bar]'),
        currentOffsetTop   = 0

    function calculateAnchors() {

        var result = []

        nodeListAnchors.forEach((anchor) => {

            result.push({
                anchor,
                anchorLink: document.querySelector(`[data-anchor-link=${ anchor.dataset.anchor }]`),
                offsetTop: anchor.offsetTop
            })

        })

        anchors = result

    }

    function reCalculateAnchorBar() {

        anchorActiveBar.style.left  = `${ anchors[currentAnchorIndex].anchorLink.offsetLeft  }px`
        anchorActiveBar.style.width = `${ anchors[currentAnchorIndex].anchorLink.offsetWidth }px`

    }

    function setCurrentAnchorIndex(index) {

        if (currentAnchorIndex !== index) {

            currentAnchorIndex = index

            reCalculateAnchorBar()

        }

    }

    function reCalculateAnchorIndex() {

        currentOffsetTop = window.pageYOffset + (window.innerHeight / 2)

        setCurrentAnchorIndex( currentOffsetTop <= 0 ? 0 : anchors.findIndex((anchor, index) => {

            return index == anchors.length - 1 ? true : anchor.offsetTop < currentOffsetTop && anchors[index + 1].offsetTop > currentOffsetTop

        }))

    }

    calculateAnchors()
    reCalculateAnchorBar()

    setInterval(() => {

        calculateAnchors()
        reCalculateAnchorBar()

    }, 1000)

    addScrollCallback( reCalculateAnchorIndex )

    addResizeCallback(() =>{

        calculateAnchors()
        reCalculateAnchorIndex()

    })

}

function init() {

    initParallaxBackgroundElements()
    initParallaxBlockElements()
    initParallaxImageElements()
    initParallaxNavbarActive()

}

export default {
    addScrollCallback,
    addResizeCallback,
    scrollTo,
    init
}